import { userLanguage, ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { successHandler, errorHandler } from '../../../utils';
import {
  CandidateBuilder,
  RemoveCandidateFromPositionInput,
  RemoveCandidateFromPositionOuput,
} from '../candidates.types';

export const removeCandidateFromPosition = (builder: CandidateBuilder) =>
  builder.mutation<
    RemoveCandidateFromPositionOuput,
    RemoveCandidateFromPositionInput
  >({
    query: (args) => ({
      url: '/candidate-position-status/remove-candidate',
      method: 'DELETE',
      body: {
        removeCandidate: args.data,
      },
    }),
    transformResponse: (res, meta, args) => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.REMOVED_CANDIDATE_FROM_POSITION
          : SuccessMessageEn.REMOVED_CANDIDATE_FROM_POSITION,
        true
      );
      return args.data;
    },
    transformErrorResponse: (err) => {
      errorHandler(
        '[addCandidateToPositionAction]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.CandidateDeletionError
          : ErrorMessageEn.CandidateDeletionError,
        err,
        true
      );
      return err.data;
    },
    invalidatesTags: () => [{ type: 'Candidates' }],
  });
